import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function Pagination({ totalPage = 1, pageData, setPageData = () => {} }) {
    const pageCount = Math.max(1, Number(totalPage) || 1);
    const currentPage = pageData?.page || 1;

    const goBack = () => {
        if (currentPage > 1) {
            setPageData((current) => ({ ...current, page: currentPage - 1 }));
        }
    };
    const forward = () => {
        if (currentPage < pageCount) {
            setPageData((current) => ({ ...current, page: currentPage + 1 }));
        }
    };
    const getPages = () => {

        // Si hay pocas páginas, mostramos todas
        if (pageCount <= 7) {
            return Array.from(
                { length: pageCount },
                (_, i) => i + 1
            );
        }

        // Estamos al principio
        if (currentPage <= 4) {
            return [1, 2, 3, 4, 5, "...", pageCount];
        }

        // Estamos al final
        if (currentPage >= pageCount - 3) {
            return [
                1,
                "...",
                pageCount - 4,
                pageCount - 3,
                pageCount - 2,
                pageCount - 1,
                pageCount
            ];
        }

        // Estamos en medio
        return [
            1,
            "...",
            currentPage - 1,
            currentPage,
            currentPage + 1,
            "...",
            pageCount
        ];
    };

    return (
        <div className="pagination-main-div">
            <button
                disabled={currentPage === 1}
                className="pagination-button-icon-no"
                onClick={goBack}
            >
                <FaChevronLeft />
            </button>

            {getPages().map((page, i) => (

                page === "..." ? (

                    <span
                        key={`dots-${i}`}
                        className="pagination-no-selected"
                    >
                        ...
                    </span>

                ) : (
                    <button
                        key={page}
                        className={
                            page === currentPage
                                ? "pagination-button-icon-yes"
                                : "pagination-button-icon-no"
                        }
                        onClick={() => setPageData((current) => ({ ...current, page }))}
                    >
                        {page}
                    </button>
                )
            ))}
            <button
                disabled={currentPage === pageCount}
                className="pagination-button-icon-no"
                onClick={forward}
            >
                <FaChevronRight />
            </button>

        </div>
    );
}

export default Pagination;
